import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const ProjectNavigationPanel = lazy(() => import('.'))

class ProjectNavigationPanelComponent extends ReactWebComponent {
  static get observedAttributes() {
    return ['active-item', 'sticky']
  }

  override render() {
    const activeItem = this.prop('active-item')
    const sticky = this.prop('sticky') === 'true'

    return (
      <RootProviders>
        <ProjectNavigationPanel activeItem={activeItem} sticky={sticky} />
      </RootProviders>
    )
  }
}

customElements.define('project-header', ProjectNavigationPanelComponent)
